import { useState } from 'react'
import useSWR from 'swr'

import { Result } from '@/hooks/services/types'
import fetcher, { METHOD } from '@/lib/fetcher'

export const useFetch = <T, D = any, P extends boolean = false, R = P extends false ? Result<T> : T>(parmas: {
  url: string | null
  method?: METHOD
  data?: D
  config?: RequestInit
  options?: Parameters<typeof useSWR<R>>[2]
  php?: P
}) => {
  const { url, method, data, config, options, php } = parmas

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const resp = useSWR<R>(
    {
      url,
      method,
      data,
      config: { ...config },
      php
    },
    fetcher,
    {
      errorRetryCount: 5,
      dedupingInterval: 5000,
      revalidateOnFocus: false,
      ...options
    }
  )

  return resp
}

export const usePages = (initPage: number = 1, initPageSize: number = 20) => {
  const [page, setPage] = useState(initPage)
  const [pageSize, setPageSize] = useState(initPageSize)
  const [totalPage, setTotalPage] = useState<number>()

  return {
    page,
    pageSize,
    totalPage,
    setPage,
    setPageSize,
    setTotalPage
  }
}
